
import { action, observable ,toJS} from 'mobx';
import ReportPartFieldConstants from 'logic/data/Izenda.ReportPartFieldConstants';
import commonDataUtils from 'logic/Izenda.ReportDesignerCommonDataUtils';
import { CONTAINER_NAME } from 'logic/data/Izenda.ReportPartGridConstants';
import  ReportPartDetails from 'logic/models/Izenda.ReportPartDetails';
import { compose, withHandlers, withState, withProps } from 'recompose';
import {map, curry,get,find,isUndefined, uniqBy, uniq, compact,isEmpty, remove,flow,every, some, forEach} from 'lodash/fp';

const mapWithIndex = map.convert({ cap: false });
const QuerySourceField = 'Field'
const QuerySource = 'QuerySource'
export default compose(
  withState('displayQueryWrapper', 'setDisplayQueryWrapper', false),
  withState('displayTreeData', 'setTreeData', []),
  withProps((props) => ({
    treeFields: {
      selectedData: []
    },
    displayTreeData : buildTree(props.reportDesignerFieldsStore.displayFieldQuerySource)

  })),
  withHandlers({
    actionQueryWrapper: curry(actionQueryWrapper),
    onChange: action(curry(onChange)),
    onApplySeletedField: curry(onApplySeletedField)
  })
);

function buildTree(data) {
  return mapWithIndex(
    (item, index) => getNodeData(item, getNodesData(item), `${item.id}_${item.name}`, 'QuerySource', index),
    data
  );
}

function getNodesData(node) {
  return mapWithIndex(
    (field, index) => getNodeData(field, [], `${node.name}_${field.id}_${field.name}`, 'Field', index),
    node.fields
  );
}

function getNodeData(node, nodes, key, type, index) {
  return observable({
    key,
    index,
    value: node.name,
    nodes,
    checked: node.isCheck,
    nodeType: type,
    indeterminate: false
  });
}

function onChange(props, item, parent) {
  item.checked = !item.checked;
  switch (item.nodeType) {
    case QuerySourceField:
      const parentNode = parent.data;
     // parentNode.checked = every('checked', parentNode.nodes);
      parentNode.indeterminate = parentNode.checked ? false : some('checked', parentNode.nodes);
      !item.checked && UpdateCheckedQuerySource(props,item);
      break
    case QuerySource:
      item.indeterminate = false;
      forEach(node => {
        node.checked = item.checked;
        !item.checked && UpdateCheckedQuerySource(props,node);
      }, item.nodes);
      break
  }

  onChangedData(props,item);
}
function UpdateCheckedQuerySource(props:any,item:any)
{
  const {exploreStore} =props;
  exploreStore.checkedQuerySources=remove(x=>x.field.name===item.value, exploreStore.checkedQuerySources);
}
function onChangedData(props,item) {
  const result = [];
  forEach(querySource => {
      if (querySource.nodes.length==0 && querySource.checked) { 
      result.push({
        querySource: querySource.index
      });
     }
    
    forEach(field => {
      if (field.checked) {
        result.push({
          field: field.index,
          querySource: querySource.index
    
        });
      }
    }, querySource.nodes);
  }, props.displayTreeData);

 onChangeSeletedField(props,result,item);
}

function actionQueryWrapper(props) { 
  const { setDisplayQueryWrapper, displayQueryWrapper } = props;
  let toggleMenu = !displayQueryWrapper;
  setDisplayQueryWrapper(toggleMenu);
}

function onChangeSeletedField(props: any, data: any,item:any) {

  const {treeFields,reportDesignerFieldsStore,exploreStore} = props;

  treeFields.selectedData = data;
  const selectedFields = map(function(item) {
    const querySource = reportDesignerFieldsStore.displayFieldQuerySource[item.querySource];
    const field = querySource.fields[item.field];
    
    return {
      field: field,
      querySource: querySource
    };
  }, treeFields.selectedData);

    const updatedSelectedFields = UpdateSelectedFields(selectedFields,props,item)
    exploreStore.checkedQuerySources = exploreStore.checkedQuerySources.length>0 ? UpdateCheckedQuerySources(exploreStore,updatedSelectedFields,item) :updatedSelectedFields;
    exploreStore.checkedQuerySources = UniqueCheckedQuerySource(exploreStore.checkedQuerySources,item);
   // setTreeData();
}

function UpdateCheckedQuerySources(exploreStore, selectedFields,item)
{
  selectedFields.map(selectedItem=>{
    exploreStore.checkedQuerySources.push(selectedItem);
   })
   //check previous selected tables checked status and update checked querysources
   if(!item.checked)
   {
    exploreStore.checkedQuerySources = remove(x=>x.querySource.id==item.key.split('_')[0],exploreStore.checkedQuerySources)
   }
   return exploreStore.checkedQuerySources;
}

function getContainer(reportPart: ReportPartDetails) {
  const containers = get('containerCollection', reportPart);
  return find({ name: CONTAINER_NAME.COLUMNS }, containers);
}
function UpdateSelectedFields(selectedFields:any,props:any,item:any){

  const {exploreStore,reportBody,treeFields} = props;

  forEach(selectedField =>{
    //check and update for nodes of querysource where fields are undefined after searching eaxt querysource name in tree
      if(isUndefined(selectedField.field) || (item.checked && item.nodeType==QuerySource && selectedField.querySource.id==item.key.split('_')[0]))
      {
       const querySource = exploreStore.availableAllQuerySourceFields[0].querySource.filter(x=>x.id==selectedField.querySource.id);
       const fields = querySource[0].fields;
       selectedField.querySource.fields =fields;
       forEach(querySourceField =>{
       // if(querySourceField.querySourceId==item.key.split('_')[0]){
        //  querySourceField.isCheck=item.checked;
       // } 
        selectedFields.push({'field': querySourceField ,'querySource': selectedField.querySource});
       },fields)  
       selectedFields = remove(x=>isUndefined(x.field),selectedFields);
      } 
     
  },selectedFields)
//remove duplicate object from selected fields
  const updateSelectedFields = [];
  selectedFields.forEach(obj => {
    if (!updateSelectedFields.some(o => o.field.id === obj.field.id)) {
      updateSelectedFields.push({ ...obj })
    }
  });

  return updateSelectedFields;
}
function UpdateTreeData(props:any,selectedFields:any)
{
  const {exploreStore,reportDesignerFieldsStore,setTreeData} = props;
  const availableTreeData = toJS(exploreStore.availableAllQuerySourceFields);

        availableTreeData.map(item=>{
          item.querySource.map(querySourceItem=>{
          if(querySourceItem.fields && selectedFields)
          {
                selectedFields.map(item=>{
                const foundField = querySourceItem.fields.filter(x=>x.id==item.field.id);
                foundField.length>0 && querySourceItem.fields.splice(querySourceItem.fields.indexOf(foundField[0]),1);

              })
          }

          })
      });
  
  reportDesignerFieldsStore.dataTree.readDataSource(availableTreeData);
  setTreeData();
  exploreStore.availableAllQuerySourceFields =availableTreeData;
}
function UniqueCheckedQuerySource(checkedQuerySource,item)
{
  if(checkedQuerySource.length>0)
  {
   //remove duplicate object from selected fields
    const updateCheckedQuerySource = [];
    checkedQuerySource.forEach(obj => {
    if (!updateCheckedQuerySource.some(o => o.field.id === obj.field.id)) {
      updateCheckedQuerySource.push({ ...obj })
      }
    });
    return updateCheckedQuerySource;
  }
  return checkedQuerySource;
}
function onApplySeletedField(props: any) {
   const {exploreStore,reportBody,treeFields} = props;

   const selectedFields = exploreStore.checkedQuerySources

   if (!isEmpty(selectedFields)) {
  //  Collect data types + query source id's:
    const allDataTypes = flow(
      map(item => ({
        dataType: item.field.izendaDataType,
        querySourceId: item.querySource.id
      })),
      uniqBy(x => `${x.dataType}_${x.querySourceId}`),
      compact
    )(selectedFields);

    // Run preload promises:
    let preloadPromises = {
      promiseFunctions: null,
      promiseFormats: null
    };
    if (!isEmpty(allDataTypes)) {
      preloadPromises = {
        // Load functions for all selected fields
        promiseFunctions: commonDataUtils.getFunctionsData(
          ReportPartFieldConstants.FIELD_FUNCTION_MODE.FieldProperty,
          allDataTypes
        ),
        // Load formats for all selected fields
        promiseFormats: commonDataUtils.getFormatsData(
          uniq(map('dataType', allDataTypes))
        )
      };
    }

    const container = getContainer(reportBody.reportParts[0].reportPartContent);
    let position = reportBody.reportParts[0].reportPartContent.columns.elements.length;
    return Promise.map(selectedFields, item => {
     
    const querySource = item.querySource;
    const field = item.field;
    position++;
    return props.reportBody.reportParts[0]
   .insertFieldToContainer(container, field, querySource, position, null, preloadPromises)
    }).then(() => {
        props.reportDesignerFieldsStore.updateReportsParts(false,null,true);
        UpdateTreeData(props,selectedFields);
        treeFields.selectedData = [];
        exploreStore.checkedQuerySources=[];
     });
  
   } 
  
 }








// WEBPACK FOOTER //
// ./ui/share/components/controls/QueryResult/Izenda.QueryResultActions.js